import {domain} from "commons/config";
import {Container, Box, Typography, Grid, Button} from "@mui/material";
import style from "./style.module.scss";

function ShowClients() {

    function cleanCsvValue(value:string){
        return value.replace(/"/g, `"""`).replace(/,/g, `","`);
    }
    function getClients() {
        fetch(domain + "/downloadClients").then(response => {
            response.json().then(json => {
                const columns:string[] = ["firstname", "lastname", "email", "phone", "country", "town", "postcode", "message"];
                let csv = columns.join(",");
                json.forEach((client: Record<string, any>) => {
                    const id: string = Object.keys(client)[0];
                    const data: any = client[id];

                    csv += "\n" + columns.map(col=>cleanCsvValue(data[col] ?? "")).join(",");
                });
                console.log(csv);

                //download csv from string
                const element = document.createElement("a");
                element.setAttribute("href", 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                element.setAttribute("download", "Clients list.csv");
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            })
        });
    }

    return (
        <Container>
            <Box bgcolor="primary.main" color="white" className={style.titleCnt}>
                <Typography variant="h3" align="center" >
                    Clients Information
                </Typography>
            </Box>
            <br />
            <br />
            <Grid container alignItems="center" justifyContent="center" direction="column">
                <Typography variant="h5">You can now download all client information</Typography>
                <br />
                <Box className={style.downloader}>
                    <Typography variant="h6" sx={{marginRight: "10px"}}>Excel file</Typography>
                    <Button variant="contained" onClick={getClients}>Download Clients</Button>
                </Box>
            </Grid>
        </Container>
    );
}

export default ShowClients;